export const SET_PROFILE = 'SET_PROFILE';
export type SET_PROFILE_TYPE = typeof SET_PROFILE; 